import dynamic from 'next/dynamic'
import type { ComponentType } from 'react'

export const AllBlocksPayload: Record<
  string,
  ComponentType<React.PropsWithChildren<{ block: any; customProps?: any }>>
> = {
  // BlockRichText: RichTextBlock,
  blockRichText: dynamic(() =>
    import('./RichTextBlock').then((m) => m.RichTextBlock)
  ),
  // BlockCallToActionButton: CallToActionButtonBlock,
  blockCallToActionButton: dynamic(() =>
    import('./CallToActionButtonBlock').then((m) => m.CallToActionButtonBlock)
  ),
  // BlockTwoColumn: TwoColumnLayout,
  blockTwoColumn: dynamic(() =>
    import('./TwoColumnLayout').then((m) => m.TwoColumnLayout)
  ),
  // BlockOneColumn: OneColumnLayout,
  blockOneColumn: dynamic(() =>
    import('./OneColumnLayout').then((m) => m.OneColumnLayout)
  ),
  // BlockThreeColumn: ThreeColumnLayout,
  blockThreeColumn: dynamic(() =>
    import('./ThreeColumnLayout').then((m) => m.ThreeColumnLayout)
  ),
  // BlockAccordion: Accordion,
  blockAccordion: dynamic(() =>
    import('../components/Accordion').then((m) => m.Accordion)
  ),
  // BlockAccordionEntry: AccordionEntry,
  blockAccordionEntry: dynamic(() =>
    import('../components/AccordionEntry').then((m) => m.AccordionEntry)
  ),
  // BlockCustom: CustomBlock,
  blockCustom: dynamic(() =>
    import('./CustomBlocks/CustomBlock').then((m) => m.CustomBlock)
  ),
  // BlockPersonAccordion: PersonAccordion,
  blockPersonAccordion: dynamic(() =>
    import('./PersonAccordion').then((m) => m.PersonAccordion)
  ),
  // BlockImageGallery: BlockImageGallery,
  blockImageGallery: dynamic(() =>
    import('./BlockImageGallery').then((m) => m.BlockImageGallery)
  ),
  // PersonAccordionEntry: PersonAccordionEntry,
  personAccordionEntry: dynamic(() =>
    import('./PersonAccordionEntry').then((m) => m.PersonAccordionEntry)
  ),
  // BarChartWithBackground: BarChartWithBackgroundBlock,
  blockBarChartWithBackground: dynamic(() =>
    import('./BarChartWithBackground').then(
      (m) => m.BarChartWithBackgroundBlock
    )
  ),
  // BlockRibbon: BlockRibbon,
  blockRibbon: dynamic(() =>
    import('./BlockRibbon').then((m) => m.BlockRibbon)
  ),
  // BlockTable: Table,
  blockTable: dynamic(() => import('./Table/Table').then((m) => m.Table)),
  // LatestDownload: LatestDownload,
  latestDownload: dynamic(() =>
    import('./LatestDownload').then((m) => m.LatestDownload)
  ),
  // NavigationEntry: NavigationEntry,
  blockNavigationEntry: dynamic(() =>
    import('./NavigationEntry').then((m) => m.NavigationEntry)
  ),
  // BlockStockPrice: StockPriceSection,
  blockStockPrice: dynamic(() =>
    import('./StockPriceSection').then((m) => m.StockPriceSection)
  ),
  // BlockBigTitleNavigation: BigTitleNavigation,
  blockBigTitleNavigation: dynamic(() =>
    import('./BigTitleNavigation').then((m) => m.BigTitleNavigation)
  ),
  // BlockAnalystRating: AnalystRating,
  blockAnalystRating: dynamic(() =>
    import('./AnalystRatings/AnalystRating').then((m) => m.AnalystRating)
  ),
  // BlockFullsizeImage: FullsizeImage,
  blockFullsizeImage: dynamic(() =>
    import('./FullsizeImage').then((m) => m.FullsizeImage)
  ),
  // BlockPartnerGrid: PartnerGrid,
  blockPartnerGrid: dynamic(() =>
    import('./PartnerGrid').then((m) => m.PartnerGrid)
  ),
  // BlockHighlightRealEstate: BlockHighlightRealEstate,
  blockHighlightRealEstate: dynamic(() =>
    import('./BlockHighlightRealEstate').then((m) => m.BlockHighlightRealEstate)
  ),
  // BlockVideo: Video,
  blockVideo: dynamic(() => import('./Video').then((m) => m.Video)),
  // BlockLinkSection: LinkSection,
  blockLinkSection: dynamic(() =>
    import('./LinkSection').then((m) => m.LinkSection)
  ),

  // BlockTextCloud: BlockTextCloud,
  blockTextCloud: dynamic(() =>
    import('./BlockTextCloud').then((m) => m.BlockTextCloud)
  ),
  // BlockSpeechBubble: BlockSpeechBubble,
  blockSpeechBubble: dynamic(() =>
    import('./SpeechBubble').then((m) => m.BlockSpeechBubble)
  ),
  // BlockSlider: BlockSlider,
  blockSlider: dynamic(() =>
    import('./BlockSlider').then((m) => m.BlockSlider)
  ),
  // BlockSliderEntry: BlockSliderEntry,
  blockSliderEntry: dynamic(() =>
    import('./BlockSliderEntry').then((m) => m.BlockSliderEntry)
  ),
  // BlockHiddenWithConsent: HiddenWithConsent,
  blockHiddenWithConsent: dynamic(() =>
    import('./HiddenWithConsent').then((m) => m.HiddenWithConsent)
  ),
}
